<template>
  <v-navigation-drawer width="550px" absolute persistent>
    <v-btn
      color="transparent"
      @click="onBackButtonPressed"
      @mouseover="showBackButton = true"
      @mouseleave="showBackButton = false"
      depressed
      class="back-button"
    >
      <v-icon left class="pa-0"> mdi-arrow-left </v-icon>
      {{ getBackButtonText }}
    </v-btn>

    <v-list class="component_margin">
      <v-list-item>
        <RouteDescriptionComponent />
      </v-list-item>
      <v-list-item>
        <SetRouteWaypointsComponent />
      </v-list-item>
    </v-list>

    <RequestResponseSnackBar
      :value="showSuccessSnackBar"
      v-model="showSuccessSnackBar"
      text="Route created successfully"
      color="green"
    />

    <RequestResponseSnackBar
      :value="showErrorSnackBar"
      v-model="showErrorSnackBar"
      text="Error in creating route"
      color="red"
    />

    <template v-slot:append>
      <div class="navigation_drawer_append">
        <CustomThemedButton
          :disabled="isSaveButtonDisabled"
          :loading="createRouteLoading"
          color="primary"
          rounded
          block
          @click="onCreateRoutePressed"
        >
          Create
        </CustomThemedButton>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import RouteDescriptionComponent from "./components/RouteDescription.vue";
import SetRouteWaypointsComponent from "./components/SetRouteWaypoints.vue";
import RequestResponseSnackBar from "../../components/RequestResponseSnackBar.vue";
import CustomThemedButton from "../../../../core/CustomThemedButton.vue";
export default {
  name: "CreateRoute",
  components: {
    RouteDescriptionComponent,
    SetRouteWaypointsComponent,
    RequestResponseSnackBar,
    CustomThemedButton,
  },
  data: function () {
    return {
      showBackButton: false,
      showSuccessSnackBar: false,
      showErrorSnackBar: false,
    };
  },
  computed: {
    ...mapState("weatherRouting/createRouteModule", [
      "currentWayPoints",
      "createRouteLoading",
      "routeDescription",
      "createRouteSuccess",
      "createRouteFailed",
    ]),
    ...mapGetters("weatherRouting/createRouteModule", [
      "createRouteRequestFailed",
    ]),
    getBackButtonText() {
      return this.showBackButton ? "Back" : "";
    },
    isSaveButtonDisabled() {
      return this.currentWayPoints.length <= 1 || this.routeDescription == "";
    },
  },
  methods: {
    ...mapActions("weatherRouting/createRouteModule", ["createRoute"]),
    ...mapActions("weatherRouting/routesModule", ["fetchAllRoutes"]),
    async onCreateRoutePressed() {
      await this.createRoute();
    },
    async onBackButtonPressed() {
      this.$router.go(-1);
      this.$store.commit("weatherRouting/createRouteModule/RESET_STATE", {
        root: true,
      });
      await this.fetchAllRoutes();
    },
  },
  watch: {
    createRouteFailed: {
      handler(value) {
        if (value) {
          this.showErrorSnackBar = true;
        }
      },
      deep: true,
    },
    createRouteSuccess: {
      handler(value) {
        if (value) {
          this.showSuccessSnackBar = true;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.navigation_drawer_append {
  margin-top: 20px;
  margin-bottom: 35px;
  margin-left: 15px;
  margin-right: 15px;
}
.v-navigation-drawer {
  padding: 0 !important;
  background-color: var(--color-bg) !important;
}
.back-button {
  background-color: var(--color-bg) !important;
  color: var(--color-text) !important;
}
</style>

